import { useState } from "react";
import { ImageContainer } from "./lazyLoadImage.styled";
import { ListDefaultImg } from "app-core-img";

const PhotoDrawer = ({ Photo, OrganizationID }) => {

    const [imageDimensions, setImageDimensions] = useState<boolean>(false)

    const onLoad = ({ target: img }) => {
        let height = img.offsetHeight;
        let width = img.offsetWidth;
        if (height > width) setImageDimensions(true)
    };

    const onError = ({ target }) => {
        target.src = ListDefaultImg;
        target.onerror = null;
    };

    return (<ImageContainer >
        <div className="square-box">
            <div className={`square-content`}>
                <img
                    className={`${imageDimensions ? 'width-auto' : 'height-auto'}`}
                    onLoad={onLoad}
                    onError={onError}
                    alt={OrganizationID} src={Photo} />
            </div>
        </div>
    </ImageContainer>)
};

export default PhotoDrawer;
